export function getCookie(name: string): string | undefined {
  if (typeof document === "undefined") return undefined;
  const match = document.cookie.match(
    new RegExp(`(?:^|; )${name.replace(/([.$?*|{}()[\]\\/+^])/g, "\\$1")}=([^;]*)`)
  );
  return match ? decodeURIComponent(match[1]) : undefined;
}

export function setCookie(
  name: string,
  value: string | boolean | number,
  options: { path?: string; maxAge?: number; sameSite?: string; secure?: boolean } = {}
) {
  if (typeof document === "undefined") return;
  const encoded = `${name}=${encodeURIComponent(String(value))}`;
  const path = options.path ? `; path=${options.path}` : "";
  const maxAge = options.maxAge ? `; max-age=${options.maxAge}` : "";
  const sameSite = options.sameSite ? `; samesite=${options.sameSite}` : "";
  const secure = options.secure ? "; secure" : "";
  document.cookie = `${encoded}${path}${maxAge}${sameSite}${secure}`;
}
